<script>
	import { getContext } from 'svelte'

	const { data, xGet, yGet, x, yRange, xScale, y, height, zGet, zScale, z } =
		getContext('LayerCake')

	export let color = '#000'

	export let which = () => false

	export let invert = false
</script>

<div class="labels-group">
	{#each $data as d, i}
		{@const h = which(d, i)}
		{#if h}
			{@const xPos =
				$xGet(d) + ($xScale.bandwidth ? $xScale.bandwidth() / 2 : 0)}
			{@const yPos = $yGet(d)}
			{@const yValue = $y(d)}
			<div
				class="label"
				class:invert={!!invert}
				style="
        color: {color};
        left: {xPos}%;
        top: {yPos}%;
      ">
				{yValue}
			</div>
		{/if}
	{/each}
</div>

<style lang="scss">
	.label {
		font-weight: 500;
		font-size: 16px;
		line-height: 16px;
		position: absolute;
		transform: translate(-50%, -100%);

		&.invert {
			transform: translate(-50%, 0);
		}

		@media (max-width: 480px) {
			font-size: 14px;
			line-height: 14px;
		}
	}
</style>
